<!-- Columns -->
<div class="modal-section">
    <div id="metric-by-category-list-container"
        class="linked-lists">
        <!-- Left: Category  -->
        <div class="linked-list user-select-none">
            <div class="linked-list-header">Category</div>
            <div class="linked-list-body">
                <div class="linked-list-item"
                     *ngFor="let category of categories"
                     [ngClass]="{selected: category.category_label === categorySelected?.category_label}">
                    <div class="linked-list-item-header"
                         (click)="selectCategory(category)"
                         [attr.category-scroll-id]="metricByCategoryListId | getCategoryScrollId : category.category_label">
                        <span [textContent]="(numSelectedPerCategoryMap[category.category_label]) ?
                            category.category_label + ' (' + numSelectedPerCategoryMap[category.category_label] + ')' :
                            category.category_label">
                        </span>
                    </div>
                </div>
            </div>
        </div>
        <!--  Right: Metrics -->
        <div class="linked-list user-select-none">
            <div class="linked-list-header">Metric</div>
            <div class="linked-list-body" *ngIf="categorySelected">
                <ng-container *ngFor="let section of categorySelected.sections; first as isFirstSection">

                    <!-- Display a collapsable version of menu column if it is collapsable. -->
                    <ng-container *ngIf="useCollapsableList(categorySelected); then collapsableSections else nonCollapsableSections"></ng-container>

                    <ng-template #collapsableSections>
                        <div class="linked-list-item-body linked-list-sublist">
                            <div class="linked-list-item linked-list-item-dropdown"
                                 [ngClass]="{open: sectionIsOpenMap?.[section.section_label]}">

                                <!-- Menu Header -->
                                <div class="linked-list-item-header" (click)="toggleSection(section.section_label)"
                                     [attr.category-top-scroll-id]="isFirstSection && !section.section_label ? (metricByCategoryListId | getCategoryTopScrollId : categorySelected.category_label) : ''">
                                    <div class="btn dropdown-toggler"></div>
                                    <!-- Menu Label -->
                                    <span class="text-gray-10 linked-list-item-header-wrap">
                                        <strong [textContent]="section.section_label!"></strong>
                                    </span>
                                    <!-- Menu Selected -->
                                    <div class="linked-list-item-controls"
                                         *ngIf="selectedMetricsMap | isSectionItemSelected: categorySelected.category_label : section.section_label">
                                        <div class="btn btn-xs btn-circle btn-transparent btn-check">
                                            <svg role="img" ycnIcon [name]="'icon-check'"></svg>
                                        </div>
                                    </div>
                                </div> <!-- Menu Header -->

                                <!-- Menu Body -->
                                <div class="linked-list-item-body">
                                    <div class="linked-list-item" *ngFor="let item of section.items"
                                         [attr.metric-scroll-id]="metricByCategoryListId | getMetricScrollId : item.internal_name : categorySelected.category_label : section.section_label">
                                        <div class="linked-list-item-header"
                                             (click)="selectMetric(item, categorySelected.category_label, section.section_label)">
                                            <span [textContent]="item.label"></span>
                                            <div class="btn btn-xs btn-circle btn-transparent btn-i" *ngIf="showInfoPopover"
                                                    (click)="openMetricInfoModal(item, $event)">
                                                <svg role="img" ycnIcon [name]="'icon-info'"></svg>
                                            </div>
                                            <div class="linked-list-item-controls"
                                                 *ngIf="selectedMetricsMap | isItemSelected : item.internal_name : categorySelected.category_label : section.section_label : undefined">
                                                <div class="btn btn-xs btn-circle btn-transparent btn-check">
                                                    <svg role="img" ycnIcon [name]="'icon-check'"></svg>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="linked-list-item-body"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-template>

                    <ng-template #nonCollapsableSections>
                        <ng-container *ngFor="let item of section.items; first as isFirstSectionItem">

                            <div class="linked-list-item-header" *ngIf="isFirstSectionItem && section.section_label">
                                <span
                                    [attr.category-top-scroll-id]="isFirstSection ? (metricByCategoryListId | getCategoryTopScrollId : categorySelected.category_label) : ''"
                                    [textContent]="section.section_label">
                                </span>
                            </div>
                            <div class="linked-list-item-body linked-list-sublist">
                                <!-- Display the menu item. If the item is a submenu, display a submenu. -->
                                <ng-container *ngIf="useDropdownBlock(item); then dropdownBlock else itemBlock"></ng-container>

                                <ng-template #dropdownBlock>
                                    <!-- Sublist of metrics specific to certain periods -->
                                        <div class="linked-list-item linked-list-item-dropdown"
                                            [ngClass]="{open: submenuIsOpenMap?.[section.section_label]?.[item.menu_label!]}">

                                            <!-- Menu Header -->
                                            <div class="linked-list-item-header"
                                                 [attr.category-top-scroll-id]="isFirstSectionItem && !section.section_label ? (metricByCategoryListId | getCategoryTopScrollId : categorySelected.category_label) : ''"
                                                 (click)="toggleSubmenu(section.section_label, item.menu_label!)">
                                                <div class="btn dropdown-toggler"></div>
                                                <!-- Menu Label -->
                                                <span class="text-gray-10 linked-list-item-header-wrap">
                                                    <span [textContent]="item.menu_label!"></span>
                                                    <!-- All period metrics have the same info; display the first period's info for the entire submenu -->
                                                    <div class="btn btn-xs btn-circle btn-transparent btn-i" *ngIf="showInfoPopover"
                                                            (click)="openMetricInfoModal(item.periods[0], $event)">
                                                        <svg role="img" ycnIcon [name]="'icon-info'"></svg>
                                                    </div>
                                                </span>
                                                <!-- Menu Selected -->
                                                <div class="linked-list-item-controls"
                                                     *ngIf="selectedMetricsMap | isSubmenuItemSelected: categorySelected.category_label : section.section_label : item.menu_label!">
                                                    <div class="btn btn-xs btn-circle btn-transparent btn-check">
                                                        <svg role="img" ycnIcon [name]="'icon-check'"></svg>
                                                    </div>
                                                </div>
                                            </div> <!-- Menu Header -->

                                            <!-- Menu Body -->
                                            <div class="linked-list-item-body">
                                                <div class="linked-list-item-content">
                                                    <div class="linked-list-item-content-title">
                                                        Select a Periodicity
                                                    </div>
                                                </div>
                                                <div class="linked-list-item"
                                                     [attr.metric-scroll-id]="metricByCategoryListId | getMetricScrollId : period.internal_name : categorySelected.category_label : section.section_label : item.menu_label"
                                                     *ngFor="let period of item.periods">
                                                    <div class="linked-list-item-header"
                                                         (click)="selectMetric(period, categorySelected.category_label, section.section_label, item.menu_label!)">
                                                        <span [textContent]="period.period_label"></span>
                                                        <div class="linked-list-item-controls"
                                                             *ngIf="selectedMetricsMap | isItemSelected : period.internal_name : categorySelected.category_label : section.section_label : item.menu_label!">
                                                            <div class="btn btn-xs btn-circle btn-transparent btn-check">
                                                                <svg role="img" ycnIcon [name]="'icon-check'"></svg>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="linked-list-item-body"></div>
                                                </div>
                                            </div>
                                        </div><!-- Menu Body -->
                                </ng-template>
                                <ng-template #itemBlock>
                                    <!-- Single metric -->
                                        <div class="linked-list-item-header"
                                             [attr.metric-scroll-id]="metricByCategoryListId | getMetricScrollId : item.internal_name : categorySelected.category_label : section.section_label"
                                             (click)="selectMetric(item, categorySelected.category_label, section.section_label)">
                                            <span class="text-gray-10"
                                                  [attr.category-top-scroll-id]="isFirstSectionItem && !section.section_label ? (metricByCategoryListId | getCategoryTopScrollId : categorySelected.category_label) : ''">
                                                <span [textContent]="item.label"></span>
                                                <div class="btn btn-xs btn-circle btn-transparent btn-i" *ngIf="showInfoPopover"
                                                        (click)="openMetricInfoModal(item, $event)">
                                                    <svg role="img" ycnIcon [name]="'icon-info'"></svg>
                                                </div>
                                            </span>
                                            <div class="linked-list-item-controls" *ngIf="selectedMetricsMap | isItemSelected : item.internal_name : categorySelected.category_label : section.section_label : undefined">
                                                <div class="btn btn-xs btn-circle btn-transparent btn-check">
                                                    <svg role="img" ycnIcon [name]="'icon-check'"></svg>
                                                </div>
                                            </div>
                                        </div>
                                </ng-template>
                            </div>
                        </ng-container>
                    </ng-template>
                </ng-container>
            </div>
        </div>
    </div>
</div>

<ycn-metric-info-modal #metricInfoModal></ycn-metric-info-modal>
